import { FadeUp, MaskedLine, lineReveal } from './Reveal';
import { motion } from 'framer-motion';

export default function PageHeader({ index, eyebrow, title, description, image }) {
  return (
    <section className="relative overflow-hidden bg-navy pb-16 pt-32 text-white md:pb-24 md:pt-44" data-testid="page-header">
      <div className="absolute inset-0 bg-blueprint" aria-hidden="true" />
      <div
        className="absolute inset-0 opacity-[0.16]"
        style={image ? { backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/40 via-navy/70 to-navy" aria-hidden="true" />
      <span
        className="outline-numeral pointer-events-none absolute -bottom-8 right-4 select-none font-display text-[9rem] font-extrabold leading-none opacity-70 md:text-[16rem]"
        aria-hidden="true"
      >
        {index}
      </span>
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <span className="eyebrow">{eyebrow}</span>
        </FadeUp>
        <motion.h1
          className="mt-6 max-w-3xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl"
          variants={lineReveal}
          initial="hidden"
          animate="visible"
        >
          <MaskedLine>{title}</MaskedLine>
        </motion.h1>
        {description && (
          <FadeUp delay={0.35}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">{description}</p>
          </FadeUp>
        )}
      </div>
    </section>
  );
}
